import { forwardRef } from 'react';

export type AnchorProps = React.AnchorHTMLAttributes<HTMLAnchorElement>;
export type ButtonPropsWrapper = React.ButtonHTMLAttributes<HTMLButtonElement>;

export type ButtonWrapperProps = AnchorProps | ButtonPropsWrapper;

export const ButtonWrapper = forwardRef(function ButtonWrapper(
  { children, ...props }: { href?: string } & ButtonWrapperProps,
  ref: React.ForwardedRef<HTMLAnchorElement | HTMLButtonElement>
) {
  if (typeof props.href !== 'undefined') {
    return (
      <a
        {...(props as AnchorProps)}
        ref={ref as React.ForwardedRef<HTMLAnchorElement>}
      >
        {children}
      </a>
    );
  }

  return (
    <button
      {...(props as ButtonPropsWrapper)}
      ref={ref as React.ForwardedRef<HTMLButtonElement>}
    >
      {children}
    </button>
  );
});

export default ButtonWrapper;
